var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"send-msg-code"},[(!_vm.canSendCode)?_c('div',{staticClass:"text-btn",on:{"click":_vm.sendCode}},[_vm._v("获取验证码")]):_c('div',{staticClass:"text-btn"},[_vm._v(_vm._s(_vm.second)+"s后重发")])])
}
var staticRenderFns = []

export { render, staticRenderFns }